import React, { useMemo } from 'react'
import { AddBooking } from '../Forms/AddForm/AddBooking';

const MemoizedAddBooking = ({ isOpen, handleClose }) => {
    return useMemo(() => <AddBooking open={isOpen} handleClose={handleClose} />, [isOpen, handleClose])
}

export default MemoizedAddBooking;